import { useT } from "../lib/i18n.tsx";
import { useState } from "react";
import { api } from "../lib/api.ts";
import { useAction } from "../lib/hooks.ts";
import { Button, Card, ErrorNotice, Field, Input } from "../components/ui.tsx";
import { SelettoreTema } from "../components/Tema.tsx";

/**
 * Primo avvio.
 *
 * Compare solo su un'installazione senza utenti. Spiega cosa sta per succedere
 * invece di limitarsi a chiedere due campi: è il primo contatto con Portman.
 */
export function SetupPage({ onCompletato }: { onCompletato: () => void }) {
  const [token, setToken] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [conferma, setConferma] = useState("");
  const t = useT();

  const { run, running, error } = useAction(async () => {
    await api.post("/setup", { token, username, password });
    onCompletato();
  });

  const discordanti = conferma.length > 0 && password !== conferma;

  return (
    <div className="mx-auto flex min-h-screen max-w-md items-center px-5">
      {/* Anche prima di entrare si sceglie come guardare lo schermo. */}
      <div className="fixed top-4 right-5">
        <SelettoreTema />
      </div>

      <Card className="w-full p-7">
        <h1 className="text-xl font-semibold">{t.t("primoAvvio.titolo")}</h1>
        <p className="mt-1.5 text-sm tenue">{t.t("primoAvvio.intro")}</p>

        <form
          className="mt-6 space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            void run();
          }}
        >
          <Field
            label={t.t("primoAvvio.token")}
            hint={t.t("primoAvvio.tokenAiuto")}
          >
            <Input
              value={token}
              onChange={(e) => setToken(e.target.value.trim())}
              autoComplete="off"
              spellCheck={false}
              autoFocus
              required
            />
          </Field>

          <Field label={t.t("accesso.utente")}>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>

          <Field label={t.t("accesso.password")} hint={t.t("primoAvvio.passwordAiuto")}>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Field>

          <Field label={t.t("primoAvvio.ripeti")}>
            <Input
              type="password"
              value={conferma}
              onChange={(e) => setConferma(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Field>

          {discordanti && <p className="text-sm text-red-600">{t.t("primoAvvio.discordanti")}</p>}
          <ErrorNotice error={error} />

          <Button
            type="submit"
            variant="primary"
            className="w-full"
            loading={running}
            disabled={discordanti || password.length === 0}
          >
            {t.t("primoAvvio.crea")}
          </Button>
        </form>
      </Card>
    </div>
  );
}
